import { render } from "./Ping.vue?vue&type=template&id=6f1a3f64&scoped=true"
import script from "./Ping.vue?vue&type=script&lang=js"
export * from "./Ping.vue?vue&type=script&lang=js"

import "./Ping.vue?vue&type=style&index=0&id=6f1a3f64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1a3f64"]])

export default __exports__